module.exports = __webpack_public_path__ + "static/media/code-logo.6658ccc4.svg";